import { Component, Inject, OnInit, ViewChild, NgZone } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { CdkVirtualScrollViewport } from "@angular/cdk/scrolling";

import * as _ from "lodash";
import {
  faChevronUp,
  faChevronDown,
  faChevronRight,
} from "@fortawesome/pro-solid-svg-icons";
import { faSearch } from "@fortawesome/pro-light-svg-icons";
import { SelectionModel } from "@angular/cdk/collections";
import { MatTableDataSource } from "@angular/material/table";
import { DatapointService } from "@services/datapoint.service";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort, MatSortable } from "@angular/material/sort";
import { timer } from "rxjs";
import {
  debounceTime,
  filter,
  map,
  pairwise,
  throttleTime,
} from "rxjs/operators";

import { CanvasService } from "@services/canvas.service";
@Component({
    selector: "app-canvas-search",
    templateUrl: "./canvas-search.component.html",
    styleUrls: ["./canvas-search.component.scss"],
    standalone: false
})
export class CanvasSearchDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private ngZone: NgZone,
    private fb: UntypedFormBuilder,
    public datapointService: DatapointService,
    public canvasService: CanvasService,
    public dialogRef: MatDialogRef<CanvasSearchDialogComponent>
  ) {
    if (data) {
      this.canvasType = data.canvasType;
    }
  }
  @ViewChild(MatPaginator) paginator: MatPaginator | undefined;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild("scroller") scroller!: CdkVirtualScrollViewport;
  datasets: any = [];

  faChevronDown = faChevronDown;
  faChevronUp = faChevronUp;
  faChevronRight = faChevronRight;
  faSearch = faSearch;

  public fieldForm!: UntypedFormGroup;
  canvasType: string = "";
  public errorText: string = "Search for an existing chart to add to your ";
  public error: string = this.errorText;
  public page: number = 1;
  public count: number = 50;
  public dataFields: any[] = [];
  public canvasFields: any[] = [];
  public fieldItem: any;
  showData = false;
  displayedColumns: string[] = ["select", "type", "name", "dataset"];
  dataSetListing: any;
  existingDataFields: any;
  dataSource: any;
  selection: any;
  filterValues: any = {};
  loading = false;
  searching = false;
  timer: any;
  firstTime = true;
  public moreFilters: boolean = true;

  search() {
    let searchTerm = this.fieldForm.controls["field"].value;
    if (searchTerm.length > 0) {
      if (searchTerm.length < 3) {
        this.error = "You have to provide at least 3 characters to search";
        this.searching = false;
        setTimeout(() => (this.error = this.errorText), 2000);
        return;
      }

      this.page = 1;
      this.moreFilters = true;
      this.loading = true;
      this.searching = true;
      this.canvasService
        .searchCanvases(searchTerm, this.count, this.page)
        .subscribe((success: any) => {
          if (success.data <= 0) {
            this.error = "No results found";
            this.searching = false;
            this.dataFields = [];
            // this.canvasMenuTrigger.closeMenu();

            setTimeout(() => {
              this.error = this.errorText;
            }, 2000);
            return;
          } else {
            this.dataFields = success.data;
            this.loading = false;
            this.searching = false;
            this.error = "";
            // this.canvasMenuTrigger.openMenu();

            if (success.data.length < this.count) {
              this.moreFilters = false;
            }
            if (this.moreFilters) {
              this.scroller
                .elementScrolled()
                .pipe(
                  map(() => this.scroller.measureScrollOffset("bottom")),
                  pairwise(),
                  filter(([y1, y2]) => y2 < y1 && y2 < 140),
                  throttleTime(500)
                )
                .subscribe(() => {
                  this.ngZone.run(() => {
                    this.fetchMore();
                  });
                });
            }
          }
        });
    }
  }
  fetchMore() {
    let searchTerm = this.fieldForm.controls["field"].value;
    this.page = this.page + 1;
    if (this.moreFilters) {
      this.canvasService
        .searchCanvases(searchTerm, this.count, this.page)
        .subscribe((success: any) => {
          this.loading = true;
          timer(1000).subscribe(() => {
            const searchData = success.data;
            this.dataFields = [...this.dataFields, ...searchData];
          });

          if (success.data.length < this.count) {
            this.moreFilters = false;
          }
        });
    } else {
      this.loading = false;
    }
  }
  addChartToReport(id: number) {
    this.dialogRef.close(id);
  }

  clearTimeout() {
    const that = this;
    clearTimeout(this.timer);
    this.timer = setTimeout(function () {
      that.search();
    }, 2000);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  initForm() {
    this.fieldForm = this.fb.group({
      field: new UntypedFormControl(),
    });
    // setting a debounce after keyup
    this.fieldItem = this.fieldForm.controls["field"].valueChanges
      .pipe(debounceTime(1000))
      .subscribe(() => this.search());
  }
  ngOnInit(): void {
    this.initForm();
  }
}
